module.exports = __webpack_public_path__ + "assets/img/home_s_i1.dd7dcc6b.png";